/**
 * Generates a URL-friendly slug from a string
 */
export function generateSlug(text: string): string {
  return text
    .toLowerCase()
    .trim()
    // Replace spaces and underscores with hyphens
    .replace(/[\s_]+/g, '-')
    // Remove accents and diacritics
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    // Remove special characters except hyphens
    .replace(/[^a-z0-9-]/g, '')
    // Replace multiple consecutive hyphens with single hyphen
    .replace(/-+/g, '-')
    // Remove leading and trailing hyphens
    .replace(/^-+|-+$/g, '');
}

/**
 * Creates a slug URL with ID embedded at the end (e.g., "quiz-title-123abc")
 */
export function createSlugWithId(title: string, id: string): string {
  const slug = generateSlug(title);
  return slug ? `${slug}-${id}` : id;
}

/**
 * Extracts the ID from a slug (assumes format: "title-slug-id")
 * The ID is expected to be the last part after the final hyphen
 */
export function extractIdFromSlug(slug: string): string {
  // If it's already a valid MongoDB ObjectId (24 hex chars), return as is
  if (/^[0-9a-fA-F]{24}$/.test(slug)) {
    return slug;
  }
  
  // Extract the last part after the last hyphen
  const parts = slug.split('-');
  const potentialId = parts[parts.length - 1];
  
  // Check if it looks like a MongoDB ObjectId
  if (/^[0-9a-fA-F]{24}$/.test(potentialId)) {
    return potentialId;
  }
  
  // If not found, return the whole slug (fallback)
  return slug;
}
